import { render, staticRenderFns, recyclableRender, components } from "./mplogin.vue?vue&type=template&id=4ecabf57&"
var renderjs
import script from "./mplogin.vue?vue&type=script&lang=js&"
export * from "./mplogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/mplogin.vue"
export default component.exports